module.exports = __webpack_public_path__ + "img/Services_Recall_3_Set.bea697fe.png";